import {lazy} from '@aboutyou/lazy-imports';

export const CampaignRefreshPopup = lazy(() =>
  import('./CampaignRefreshPopup.eager').then(mod => ({
    default: mod.CampaignRefreshPopup,
  })),
);
